import { render, staticRenderFns } from "./AddGroupMember.vue?vue&type=template&id=2dcc0f90&"
import script from "./AddGroupMember.vue?vue&type=script&lang=js&"
export * from "./AddGroupMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports